// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"5594":"components-OrderStatus","9777":"recorder"}[chunkId] || chunkId) + ".js";
};